module.exports = new __parcel__URL__("objective_retweet_button.785f1cb1.png").toString();